import { Filter, Form } from '@/components'
import { singularStatusMapLabel as castrationStatusMap } from '@/constants/castration'
import { clinicalCareStatus } from '@/constants/clinicalCares'
import PropTypes from 'prop-types'
import React from 'react'

const statusMaps = {
  castration: castrationStatusMap,
  clinicalCare: clinicalCareStatus,
}

const statusLabels = {
  castration: 'Status da castração',
  clinicalCare: 'Status do atendimento',
}

function MessagesFilter({ type }) {
  return (
    <Filter
      initialValues={{
        status_eq: '',
        animalName_cont: '',
        tutorName_cont: '',
        authorName_cont: '',
        clinicName_cont: '',
        onlyUnread: false,
      }}
      title="Filtrar mensagens"
      renderForm={() => (
        <>
          <Form.Group>
            <Form.Switch className="form-switch" key="onlyUnread" style={{ marginTop: 15 }}>
              <Form.ValidationField
                type="checkbox"
                name="onlyUnread"
                id="onlyUnread"
              />
              <i className="form-icon" />
              &nbsp;Mostrar apenas não lidas
            </Form.Switch>
          </Form.Group>
          <div className="divider text-center" data-content="Pet" />
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="animalName_cont">Nome do pet</Form.Label>
            <Form.ValidationField
              name="animalName_cont"
              className="input-sm"
              autoFocus
              id="animalName_cont"
              autoComplete="none"
              placeholder="Totó da Silva"
            />
          </Form.Group>
          <div className="divider text-center" data-content="Tutor" />
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="tutorName_cont">Nome do tutor</Form.Label>
            <Form.ValidationField
              name="tutorName_cont"
              className="input-sm"
              id="tutorName_cont"
              autoComplete="none"
              placeholder="Fulano da Silva"
            />
          </Form.Group>
          {
            type === 'clinicalCare' && (
              <>
                <div className="divider text-center" data-content="Solicitante" />
                <Form.Group>
                  <Form.Label className="text-sm" htmlFor="authorName_cont">Nome do solicitante</Form.Label>
                  <Form.ValidationField
                    name="authorName_cont"
                    className="input-sm"
                    id="authorName_cont"
                    autoComplete="none"
                    placeholder="Fulano da Silva"
                  />
                </Form.Group>
              </>
            )
          }
          <div className="divider text-center" data-content="Clínica" />
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="clinicName_cont">Nome da clínica</Form.Label>
            <Form.ValidationField
              name="clinicName_cont"
              className="input-sm"
              id="clinicName_cont"
              autoComplete="none"
              placeholder="Clínica Teste"
            />
          </Form.Group>
          <div className="divider text-center" data-content="Status" />
          <Form.Group>
            <Form.Label htmlFor="status_eq">{statusLabels[type]}</Form.Label>
            <Form.ValidationField name="status_eq">
              {
                ({ field }) => (
                  <Form.Select
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    id="status_eq"
                    className="select-sm"
                    placeholder={statusLabels[type]}
                  >
                    <option value="">Todos os status</option>
                    {
                      Object.entries(statusMaps[type]).map(([value, label]) => (
                        <option key={value} value={value}>{label}</option>
                      ))
                    }
                  </Form.Select>
                )
              }
            </Form.ValidationField>
          </Form.Group>
        </>
      )}
    />
  )
}

MessagesFilter.propTypes = {
  type: PropTypes.oneOf(['castration', 'clinicalCare']).isRequired,
}

export default MessagesFilter
